const markerInfoTemplate = (params) => {
    return `
            <div class="location-content">
                <div>
                   <img src="${params.photoSrc}" class="location-image">
                </div>
                <div class="marker-text-content">
                    <div class="location-price">
                        <a href="${params.url}">
                            ${'$' + params.price}
                        </a>
                    </div>
                    <div class="location-name">
                        ${params.name}
                    </div>
                    <div class="location-description">
                        ${params.description}
                    </div>
                </div>
            </div>
        `;
};

export {markerInfoTemplate};
